import { GlobeIcon } from 'lucide-react';
import StyledTooltipContainer from '../styled/StyledTooltipContainer';
import { SupportedLocale } from '@/types/supported-locale.type';
import { useLanguage } from '@/contexts/LanguageContext';

interface TranslateIconProps {
  translateFields: () => Promise<void>;
  isTranslating: boolean;
  language?: SupportedLocale;
  hidden?: boolean;
}

const TranslateIcon = ({
  translateFields,
  isTranslating,
  language,
  hidden = false,
}: TranslateIconProps) => {
  const { currentLanguage } = useLanguage();

  if ((language && currentLanguage === language) || hidden) return null;

  return (
    <StyledTooltipContainer tooltipMessage="Traduire">
      <GlobeIcon
        className="w-5 h-5 bg-warning-100 stroke-warning-600 cursor-pointer hover:stroke-warning-700"
        onClick={translateFields}
        style={{ opacity: isTranslating ? 0.5 : 1 }}
      />
    </StyledTooltipContainer>
  );
};

export default TranslateIcon;
